'use client'

import { Dialog } from '@vinted/web-ui'

import { ErrorItem } from '@marketplace-web/core-api/api-client-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  validationError?: Array<ErrorItem>
  title?: string
  bodyText?: string
  confirmText?: string
  onSubmit: () => void
  onClose: () => void
}

const ResolveIssueConfirmationModal = ({
  isOpen,
  onSubmit,
  validationError,
  onClose,
  title,
  bodyText,
  confirmText,
}: Props) => {
  const translate = useTranslate('resolve_issue.modal')

  return (
    <Dialog
      show={isOpen}
      title={title}
      body={
        <>
          {bodyText}
          {validationError}
        </>
      }
      actions={[
        {
          text: confirmText,
          style: Dialog.ActionStyling.Filled,
          callback: onSubmit,
        },
        {
          text: translate('actions.cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
        },
      ]}
    />
  )
}

export default ResolveIssueConfirmationModal
